"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_dom_1 = require("react-router-dom");
var reactstrap_1 = require("reactstrap");
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var Main_1 = __importDefault(require("components/Layout/Main"));
var OptimiseAction_1 = __importDefault(require("components/Optimise/OptimiseAction"));
var OptimiseOverviewStats_1 = __importDefault(require("components/Optimise/OptimiseStats/OptimiseOverviewStats"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var SortableHeaderCell_1 = __importDefault(require("containers/MyStack/styles/SortableHeaderCell"));
var Table_1 = __importDefault(require("shared/components/Table"));
var TableHeader_1 = __importDefault(require("shared/components/Table/TableHeader"));
var HoCs_1 = require("utils/HoCs");
var single_1 = require("utils/selectors/single");
var hooks_2 = require("./hooks");
var OptimiseFilters_1 = __importDefault(require("./OptimiseFilters"));
var utils_1 = require("./utils");
var PREFIX = 'index';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    stickyWrapper: "".concat(PREFIX, "-stickyWrapper"),
    serviceTableWrapper: "".concat(PREFIX, "-serviceTableWrapper"),
};
// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.wrapper)] = {
            width: 'calc(100% - 28px)',
            marginTop: theme.spacing(1),
            marginLeft: theme.spacing(1),
            marginBottom: theme.spacing(4),
        },
        _b.display = 'flex',
        _b.height = '100%',
        _b[".".concat(classes.stickyWrapper)] = {
            width: '100%',
            backgroundColor: '#fff',
            zIndex: 20,
            paddingTop: theme.spacing(5),
            position: 'sticky',
            top: 0,
            marginBottom: theme.spacing(4),
        },
        _b[".".concat(classes.serviceTableWrapper)] = {
            width: 874,
        },
        _b);
});
var Recommendations = function () {
    var _a, _b;
    var _c = __read(react_1.default.useState(null), 2), openRecommendation = _c[0], setOpenRecommendation = _c[1];
    var currentRecArr = [interfaces_1.RECOMMENDATIONS_TYPE.FX, interfaces_1.RECOMMENDATIONS_TYPE.NEGOT];
    // ToDo: use redux
    // to update
    var _d = __read((0, hooks_2.useGetPageData)(), 7), defaultSortedRecommendations = _d[0], setOwnersToFilterBy = _d[1], ownersToFilterBy = _d[2], setStatusToFilterBy = _d[3], statusToFilterBy = _d[4], recommendationsGroups = _d[5], isCalculating = _d[6];
    var filteredRecGroups = (_b = (_a = Object.keys(recommendationsGroups)) === null || _a === void 0 ? void 0 : _a.filter(function (key) { return currentRecArr.includes(key); })) === null || _b === void 0 ? void 0 : _b.reduce(function (obj, key) {
        var _a;
        return (__assign(__assign({}, obj), (_a = {}, _a[key] = recommendationsGroups[key], _a)));
    }, {});
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var _e = __read((0, react_1.useState)(profile === null || profile === void 0 ? void 0 : profile.isAdmin), 1), isAdmin = _e[0];
    // removed optional chaining because null?.FIELD is undefined
    var filteredRec = defaultSortedRecommendations
        && defaultSortedRecommendations.filter(function (rec) { return currentRecArr.includes(rec.type); });
    // to update??
    var sortedRecommendations = (0, hooks_1.useSortArray)(filteredRec, { currentAssignee: utils_1.getCurrentAssigneeName });
    var location = (0, react_router_dom_1.useLocation)();
    var selectedRecTypes = (0, utils_1.getSelectedRecommendationTypes)(location);
    if (!(0, react_redux_firebase_1.isLoaded)(sortedRecommendations) || ((0, react_redux_firebase_1.isEmpty)(sortedRecommendations) && isCalculating)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    if (sortedRecommendations === null || sortedRecommendations.length === 0) {
        return ((0, jsx_runtime_1.jsx)(Main_1.default, __assign({ hasSidebar: true }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('ds-list mx-auto px-7 mt-8', classes.serviceTableWrapper) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.wrapper }, { children: "No recommendations for you" })) })) })));
    }
    return (((0, jsx_runtime_1.jsxs)(Root, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Recommendations", description: "Recommendations" }), (0, jsx_runtime_1.jsxs)(Main_1.default, __assign({ hasSidebar: true }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('mx-auto', classes.serviceTableWrapper) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.wrapper }, { children: (0, jsx_runtime_1.jsx)(OptimiseOverviewStats_1.default, { recommendations: filteredRecGroups, selectedRecommendations: selectedRecTypes }) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('ds-list mx-auto', classes.serviceTableWrapper) }, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.Row, __assign({ className: "ds-list__content pl-5" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.stickyWrapper }, { children: [(0, jsx_runtime_1.jsx)(OptimiseFilters_1.default, { ownersToFilterBy: ownersToFilterBy, setStatusToFilterBy: setStatusToFilterBy, statusToFilterBy: statusToFilterBy, sortedRecommendations: sortedRecommendations }), (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ sx: {
                                            border: '1px solid #e0e0e0', borderRadius: '6px', py: 0, px: 4, m: 1, maxWidth: 830,
                                        } }, { children: [(0, jsx_runtime_1.jsxs)(TableHeader_1.default, { children: [(0, jsx_runtime_1.jsx)(SortableHeaderCell_1.default, { text: "", colSpan: 2, padding: "none" }), (0, jsx_runtime_1.jsx)(SortableHeaderCell_1.default, { text: "Opportunity", colSpan: 4, padding: "none", sortKey: "type" }), (0, jsx_runtime_1.jsx)(SortableHeaderCell_1.default, { text: "Savings / yr", colSpan: 9, padding: "none", align: "center", sortKey: "potentialSavings" }), (0, jsx_runtime_1.jsx)(SortableHeaderCell_1.default, { text: "Tool", colSpan: 8, padding: "none", align: "center", sortKey: "service.name" }), (0, jsx_runtime_1.jsx)(SortableHeaderCell_1.default, { text: "", colSpan: 2, padding: "none" }), isAdmin && (0, jsx_runtime_1.jsx)(SortableHeaderCell_1.default, { text: "(o)", colSpan: 2, padding: "none", align: "center" })] }), (0, jsx_runtime_1.jsx)(material_1.TableBody, { children: sortedRecommendations.map(function (recommendation) { return ((0, jsx_runtime_1.jsx)(OptimiseAction_1.default, { recommendation: recommendation, onClickRow: setOpenRecommendation, showServiceStat: true, isOpen: recommendation.id === (openRecommendation === null || openRecommendation === void 0 ? void 0 : openRecommendation.id), isAdmin: isAdmin }, recommendation.id)); }) })] }))] })) })) }))] }))] })));
};
exports.default = react_1.default.memo((0, HoCs_1.HasCompanyHoC)((0, SortHoC_1.default)(Recommendations)));
